import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import { constants } from "@qgiv/core-js";
import { SEO } from "@qgiv/core-donor";
import RegistrationBase from "../templates/RegistrationBase";
import ConnectedStorePageContent from "./ConnectedStorePageContent";
import ConnectedUpdateProductModalOpen from "./ConnectedUpdateProductModalOpen";
import ProductModal from "./ProductModal";
import ConnectedEarlyRegistrationSubmit from "../../common/EarlyRegistrationSubmit/ConnectedEarlyRegistrationSubmit";
import ErrorDisplay from "../../common/ErrorDisplay";

const StorePage = ({
    baseUrl,
    currentPage,
    documentTitle,
    erroredEntities = [],
    redirect = "",
    hasProducts = true,
    allowEarlyFormSubmissionStorePage = false,
    updateCurrentPage = () => {},
    navigate,
}) => {
    const {
        ENUMS: {
            DefaultView: { STANDARD_P2P_STORE },
        },
    } = constants;
    const [toPayment, setToPayment] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [submitFullForm, setSubmitFullForm] = useState(false);
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        if (currentPage !== STANDARD_P2P_STORE) {
            updateCurrentPage(STANDARD_P2P_STORE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    useEffect(() => {
        if (!hasProducts) {
            setToPayment(true);
        }
    }, [hasProducts]);

    const onSubmit = () => {
        setTimeout(() => {
            // TODO: address what need to be done here with limits/inventory
            // Since we moved the form to the modal, need to scope what is needed here
            // beyond moving to payment page
            if (!allowEarlyFormSubmissionStorePage) {
                window.scrollTo(0, 0);
                setToPayment(true);
            } else {
                setSubmitFullForm(true);
            }
            // // Navigate to payment page
        }, 500);
    };

    const formikProps = {
        onSubmit,
    };

    useEffect(() => {
        // This prevents flash of outdated content from displaying
        setIsVisible(true);
    }, []);

    // does not like running navigate on page load
    useEffect(() => {
        if (redirect) {
            setTimeout(() => {
                navigate(redirect);
            }, 10);
        }
    }, [redirect, navigate]);

    useEffect(() => {
        if (toPayment) {
            navigate(`${baseUrl}/form/payment`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toPayment]);

    return (
        isVisible && (
            <Formik {...formikProps}>
                <RegistrationBase>
                    <SEO title={documentTitle} description="" />
                    <ErrorDisplay
                        errors={errors}
                        setErrors={setErrors}
                        erroredEntities={erroredEntities}
                    />
                    <Form>
                        <ConnectedStorePageContent />
                        <ConnectedUpdateProductModalOpen />
                        <ProductModal />
                        {submitFullForm && (
                            <ConnectedEarlyRegistrationSubmit
                                setErrors={setErrors}
                            />
                        )}
                    </Form>
                </RegistrationBase>
            </Formik>
        )
    );
};

StorePage.propTypes = {
    currentPage: PropTypes.number.isRequired,
    documentTitle: PropTypes.string.isRequired,
    erroredEntities: PropTypes.arrayOf(PropTypes.shape({})),
    hasProducts: PropTypes.bool.isRequired,
    redirect: PropTypes.string,
    allowEarlyFormSubmissionStorePage: PropTypes.bool.isRequired,
    updateCurrentPage: PropTypes.func.isRequired,
    baseUrl: PropTypes.string.isRequired,
    navigate: PropTypes.func.isRequired,
};

export default StorePage;
